import styled from "styled-components";

export const CreateFlowProgramManagerContainer = styled.div``;

export const ErrorMessage = styled.span`
  color: red; /* Customize the error message color */
  font-size: 14px; /* Customize the font size */
  margin-bottom: 8px; /* Add some spacing below the error message */
`;
